import { render } from "./Recherche_Developpment.vue?vue&type=template&id=ef0f33e2&scoped=true"
import script from "./Recherche_Developpment.vue?vue&type=script&lang=js"
export * from "./Recherche_Developpment.vue?vue&type=script&lang=js"

import "./Recherche_Developpment.vue?vue&type=style&index=0&id=ef0f33e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0f33e2"]])

export default __exports__